<template>
  <table class="table table-hover mb-0">
    <thead class="thead-light">
      <tr>
        <th style="min-width:250px">Product</th>
        <th v-if="prompt_fulfill && order.products[0].fulfillment_type === 'product_units'">Assign Units</th>
        <th class="text-center">Status</th>
        <th class="text-right" style="width:100px">Quantity</th>
        <th class="text-right" style="width:150px">Price</th>
      </tr>
    </thead>
    <tbody>
      <order-product v-for="(product,k) in order.products" :key="k" :order="order" :product="product" :prompt_fulfill="prompt_fulfill"></order-product>
    </tbody>
    <tfoot>
      <tr v-for="(total, k) in order.totals" :key="k">
        <td :colspan="prompt_fulfill && order.products[0].fulfillment_type === 'product_units' ? 4 : 3" class="text-right">
          {{ total.name }}
          <p v-if="total.description" class="small text-muted mb-0">{{ total.description }}</p>
        </td>
        <td class="text-right">{{ total.amount | numberToRs }}</td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import OrderChangeProductStatus from './ChangeProductStatus'
import OrderProductAssignBarcodes from './ProductAssignBarcodes'
import OrderProduct from './Product'

export default {
  name: 'OrderProducts',
  components: {
    OrderProduct,
    OrderProductAssignBarcodes,
    OrderChangeProductStatus
  },
  props: ['order', 'prompt_fulfill']
}
</script>

<style scoped>
  table th:first-child,
  table td:first-child {
    padding-left: 20px;
  }
  table th:last-child,
  table td:last-child {
    padding-right: 20px;
  }
  table tfoot td {
    border-color: #eee;
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/partials/Products.vue